import { CellProps } from 'react-table';
import AutocompleteV2 from '../../../../component/AutocompleteObjectV2';
import { DEPARTMENT_CONFIG_TYPE, TERM_CLASS_IDS } from '../../../../utils/Constant';
import EditableCell from './EditableCell';
import useDepartmentOptions from './hooks/useDepartmentOptions';

const Select = ({ setEnableEditing, updateRowData, row }: any) => {
	const rowData = row.original;

	const sampleDepartmentDefault = rowData?.attributes?.deptSamplingDeptCode
		? [
				{
					name: rowData?.attributes?.deptSamplingDeptName,
					value: rowData?.attributes?.deptSamplingDeptCode,
				},
		  ]
		: [];

	const sampleDepartmentConfigByTerm = rowData?.attributes?.deptSamplings
		? JSON.parse(rowData?.attributes?.deptSamplings).map((item: any) => ({
				name: item?.name,
				value: item?.code,
		  }))
		: [];

	const currentValue = rowData?.samplingDeptCode
		? [
				{
					name: rowData?.samplingDeptName,
					value: rowData?.samplingDeptCode,
				},
		  ]
		: sampleDepartmentDefault;

	const { departmentOptions } = useDepartmentOptions({
		defaultOptions: [
			...currentValue,
			...sampleDepartmentDefault,
			...sampleDepartmentConfigByTerm,
		],
		departmentConfigType: DEPARTMENT_CONFIG_TYPE.SAMPLE,
	});

	return (
		<AutocompleteV2
			autoFocus
			options={departmentOptions}
			value={currentValue}
			name="sampleDepartment"
			onChange={(selectedOption: any) => {
				updateRowData(row.index, (value: any) => ({
					...value,
					samplingDeptCode: selectedOption?.value,
					samplingDeptName: selectedOption?.name,
				}));
				setEnableEditing(false);
			}}
			onBlur={() => {
				setEnableEditing(false);
			}}
			className="autocomplete-custom-tiep-nhan radius spaces width-100 h-25"
			isClearable={false}
		/>
	);
};

const SampleDepartmentCell = ({ row, tableOptions }: CellProps<any>) => {
	const { updateRowData } = tableOptions;
	const rowData = row.original;
	const textValue = rowData?.samplingDeptName || rowData?.attributes?.deptSamplingDeptName;

	return (
		<EditableCell
			disabled={rowData?.classId !== TERM_CLASS_IDS.XET_NGHIEM}
			editComponent={(props: any) => (
				<Select row={row} updateRowData={updateRowData} {...props} />
			)}
			textValue={textValue}
		/>
	);
};

export default SampleDepartmentCell;
